export default __webpack_public_path__ + "static/media/duitnow.33d49a4f.png";